import styled, { css } from "styled-components";

import { styles } from "../Input/styles";

interface IProps {
  verifying?: boolean;
  error?: boolean;
  validate?: boolean;
  disabled?: boolean;
}

export const Container = styled.div`
  flex: 1;
`;

export const Input = styled.div<IProps>`
  display: flex;

  margin-top: 0.5rem;

  border-radius: 4px;

  &:focus-within {
    box-shadow: var(--input-focus-shadow);
  }

  ${(props) =>
    props.disabled &&
    css`
      input {
        background-color: var(--input-disabled-background);
        border-color: var(--input-disabled-border);
      }

      .flag-container-tel {
        background-color: var(--input-disabled-background);
        border-color: var(--input-disabled-border);
      }

      &&:hover {
        input {
          border-color: var(--input-disabled-border);
        }

        .flag-container-tel {
          border-color: var(--input-disabled-border);
        }
      }
    `}

  &:hover {
    input {
      border-color: var(--input-hover-border);
      margin: 0;
    }

    .flag-container-tel {
      border-color: var(--input-hover-border);
    }
  }

  input {
    ${styles}

    width: 100%;

    border-radius: 0 4px 4px 0;
    margin: 0;

    &:focus {
      box-shadow: none;
    }
  }
`;

export const FlagContainer = styled.div<IProps>`
  ${styles}

  border-radius: 4px 0 0 4px;
  border-right: 0;

  display: flex;
  align-items: center;

  margin: 0;

  svg {
    width: 38px;
  }
`;
